/** Soft, friendly feedback beeps — no scary sounds. */

let ctx: AudioContext | null = null;

function getCtx(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  try {
    const Ctx = window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!Ctx) return null;
    if (!ctx) ctx = new Ctx();
    void ctx.resume();
    return ctx;
  } catch {
    return null;
  }
}

function tone(freq: number, duration: number, type: OscillatorType = 'sine', gain = 0.08) {
  const audio = getCtx();
  if (!audio) return;
  const osc = audio.createOscillator();
  const g = audio.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  g.gain.value = gain;
  g.gain.exponentialRampToValueAtTime(0.001, audio.currentTime + duration);
  osc.connect(g);
  g.connect(audio.destination);
  osc.start();
  osc.stop(audio.currentTime + duration);
}

export function playDumpSound() {
  tone(320, 0.12, 'triangle', 0.09);
  window.setTimeout(() => tone(480, 0.18, 'sine', 0.07), 80);
}

export function playWobbleSound() {
  tone(180, 0.1, 'sine', 0.05);
  window.setTimeout(() => tone(160, 0.1, 'sine', 0.04), 90);
}

export function playPickupSound() {
  tone(520, 0.08, 'sine', 0.06);
  window.setTimeout(() => tone(720, 0.1, 'sine', 0.05), 60);
}

export function playSurpriseSound() {
  tone(600, 0.08, 'sine', 0.06);
  window.setTimeout(() => tone(800, 0.12, 'triangle', 0.05), 70);
}

export function playCelebrateSound() {
  [523, 659, 784].forEach((f, i) => {
    window.setTimeout(() => tone(f, 0.15, 'triangle', 0.07), i * 100);
  });
}

export function playHornSound() {
  tone(220, 0.18, 'square', 0.06);
  window.setTimeout(() => tone(280, 0.22, 'square', 0.05), 100);
}

export function playRumbleSound() {
  tone(90, 0.35, 'sawtooth', 0.05);
  window.setTimeout(() => tone(70, 0.4, 'triangle', 0.04), 120);
  window.setTimeout(() => tone(110, 0.25, 'sine', 0.04), 280);
}
